module.exports = __webpack_public_path__ + "static/img/control2.3f34e7da.png";